import HttpRequest from '../http_request'
class CreditApi extends HttpRequest {
  apiGetCredit (data) {
    return this.fetch('/client/v1/invoice-approvals',data)
  }

  apiGetCreditByid(id){
    return this.fetch(`/client/v1/invoice-approvals/${id}`)
  }

  

  apiGetInvoiceShipmentOrder(data){
    return this.fetch(`/client/v1/invoice-approvals/${data.id}/invoice-approvable`,{page:data.page})
  }

  apiEditCancelCredit(data){
    return this.edit(`/client/v1/invoice-approvals/${data.id}`,data.formData)
  }
  apiCreateApproveCredit(data){
    return this.edit(`/v1/invoice-approvals/${data.id}/approve`,data.formData)
  }
  // debt
  apiGetDebt(data){
    return this.fetch(`/client/v1/credit-notes`,data)
  }

  getDebtByid(id){
    return this.fetch(`/client/v1/credit-notes/${id}`)
  }

  apiGetBank(){
    return this.fetch(`/client/v1/banks`)
  }

  apiCreateApproveCreate(data){
    return this.create(`/client/v1/invoice-approvals/${data.id}/approve`,data.formData)
  } 

  apiGetCreditNoteByid(id){
    return this.fetch(`/client/v1/credit-notes/${id}`)
  } 


  apiCreateCreditNoteDown(id){
    return this.create(`/client/v1/credit-notes/${id}/sync-tr-cloud`)
  }
  
  
  apiGetCheckCreditOrder(data){
    return this.fetch(`/client/v2/reports/shipment-orders/credit`,data)
  }


  apiGetCheckCreditSummary(data){
    return this.fetch(`/client/v2/reports/shipment-orders/credit/summary`,data)
  }

  apiGetOtherFeeAll(data){
    return this.fetch(`/client/v1/other-fees`,data)
  }
  apiGetOtherFeeSummary(data){
    return this.fetch(`/client/v1/other-fees/summary`,data)
  }
  apiCreateOtherFee(data){
    return this.create(`/client/v1/other-fees`,data)
  }

  apiEditApproveMultiService(data){
    return this.edit(`/client/v1/other-fees/bulk-approve`,data)
  }

  apiGetOtherFeeByid(id){
    return this.fetch(`/client/v1/other-fees/${id}`)
  }

  apiEditApproveOtherByid(id){
    return this.edit(`/client/v1/other-fees/${id}/approve`)
  }

  apiEditOtherFee(data){
    return this.edit(`/client/v1/other-fees/${data.id}`,data.formData)
  }

  apiDeleteOtherFee(id){
    return this.delete(`/client/v1/other-fees/${id}`)
  }

  apiCreateDisplayCredit(data){
    return this.create(`/client/v1/accounts/${data.id}/invoice-approvals`,{
      summary_date : data.formData })
  }
  
  apiGetCreditNoteGetLink(id){
    return this.fetch(`/client/v1/credit-notes/${id}/e-tax`);
  }




}
export default CreditApi